import React from "react";
import { map, mount, redirect, route } from "navi";
import { VideoChat } from "./components/VideoChat";
import { Host } from "components/room/Host";
import { twilioSyncEnabled } from "utils";

const routes = mount({
  "/": route((req) => {
    return {
      title: "Remote Guest",
      view: <VideoChat roomUid={""} />,
    };
  }),
  "/version": route(_ => {
    document.location.replace("/version.json");
    return {};
  }),
  "/:roomUid": route((req) => {
    const { roomUid } = req.params;

    return {
      title: "Remote Guest",
      view: <VideoChat roomUid={roomUid} />,
    };
  }),
  "/:roomUid/host": map((req) => {
    const { roomUid } = req.params;
    if (twilioSyncEnabled) {
      return route({
        title: "Hostin'",
        view: <Host roomUid={roomUid} />,
      });
    }

    return redirect(`/${roomUid}`);
  }),
});

export default routes;
